import clsx from 'clsx';

type StatusDotProps = {
  variant?: 'success' | 'warning' | 'error';
};

/** Shows a small colored dot to indicate status */
export function StatusDot({ variant }: StatusDotProps) {
  return (
    <span
      className={clsx(
        'inline-block h-2 w-2 rounded',
        variant === 'success' && 'bg-green-400',
        variant === 'warning' && 'bg-yellow-400',
        variant === 'error' && 'bg-red-500 ',
        !variant && 'bg-gray-400',
      )}
    />
  );
}
